// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VerticalAlignTopOutlinedSvg from "@ant-design/icons-svg/es/asn/VerticalAlignTopOutlined";
import AntdIcon from '../components/AntdIcon';

var VerticalAlignTopOutlined = function VerticalAlignTopOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: VerticalAlignTopOutlinedSvg
  }));
};

VerticalAlignTopOutlined.displayName = 'VerticalAlignTopOutlined';
export default React.forwardRef(VerticalAlignTopOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/VerticalAlignTopOutlined.js
// module id = 2025
// module chunks = 0